import { format } from "date-fns";
import { ru } from "date-fns/locale";
import React, { forwardRef, useRef } from "react";
import styled from "styled-components";
import { X2 } from "../ThePopup/styles";

// Стили компонентов
const Wrapper0 = styled.div`
  display: none;
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  display: block;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  background-color: rgba(0, 0, 0, 0.8);
  width: 1473px;
  height: 100vh;
  padding-left: 400px;
`;
const Wrapper2 = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 600px;
  border-radius: 24px;
  padding-right: 60px;
  padding-left: 60px;
`;

const Title = styled.h1`
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  margin-top: 60px;
`;

const Subtitle = styled.p`
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin-top: 40px;

  a {
    font-family: Avenir Next;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: -0.04em;
    text-align: center;
    text-decoration: none;
    color: #1983ff;
  }
`;

const InfoBox = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  border-bottom: 1px dashed #b4b4b4;
  margin-bottom: 13px;
  padding-bottom: 13px;
  margin-top: 60px;
`;
const InfoBox2 = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 26px;
`;

const Button = styled.a`
  background-color: #e0f2ff;
  color: #007bff;
  font-size: 1rem;
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d0eaff;
  }
  margin-bottom: 100px;
`;

type ThnksProps = {
  time: string;
  date: string;
};

const Thanks = forwardRef<HTMLDivElement, ThnksProps>(({ time, date }, ref) => {
  const HidePopUp = () => {
    if (ref && "current" in ref && ref.current) {
      ref.current.style.display = "none";
    }
  };

  return (
    <Wrapper0 ref={ref}>
      <Wrapper>
        <Wrapper2>
          <X2 onClick={HidePopUp} $img={require("./X.jpg")} />
          <Title>Спасибо за запись</Title>
          <Subtitle>
            Вы успешно записаны
            <a href="#">
              ‍‎ {format(date, "d MMMM", { locale: ru })} в {time} ‍‎
            </a>
            по МСК
          </Subtitle>
          <InfoBox>
            Наш менеджер предварительно свяжется с вами для подтверждения
            встречи. В день консультации вам придет ссылка на онлайн встречу в
            Telegram.
          </InfoBox>
          <InfoBox2>
            Если у вас остались вопросы относительно нашей работы, пожалуйста,
            напишите нам:
          </InfoBox2>
          <Button href={"https://t.me/ProhorovaConsult"}>
            Задать вопрос в TG
          </Button>
        </Wrapper2>
      </Wrapper>
    </Wrapper0>
  );
});

export default Thanks;
